/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Api_Keys_SubtitleInputs */



/**
* | output |
* | --- |
* | "Manage the keys used to authenticate API requests." |
*
* @param {Gateway_Sub_Api_Keys_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_api_keys_subtitle = /** @type {((inputs?: Gateway_Sub_Api_Keys_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Api_Keys_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalten Sie die Schlüssel zur Authentifizierung von API-Anfragen.")
	return /** @type {LocalizedString} */ ("Manage the keys used to authenticate API requests.")
});